export default __webpack_public_path__ + "static/media/surprise.4885974d.png";